import React, { useEffect } from 'react';
import cx from 'classnames';

import { SiteConfigManager, useApplicationState, useBetslipState } from '@atlas/core';
import { EventLink } from '@atlas/routing';
import { BetReports, MoneyValue } from '@atlas/ui';

import BetOutcomeLink from 'common/BetOutcomeLink';
import useTranslate from 'common/I18n/Interpreter';
import { useNotificationsUIContext } from 'common/Popup/NotificationsUIContext';

const QuickBetInfo = () => {
  const { amount } = useBetslipState();
  const t = useTranslate();
  const { wallet } = useApplicationState();
  const { setIsQuickBet } = useNotificationsUIContext();
  const showBottomNavigation = SiteConfigManager.getConfig(
    'config.config.sportsbook.showBottomNavigationMobile',
  );

  useEffect(() => {
    setIsQuickBet(true);

    return () => {
      setIsQuickBet(false);
    };
  }, []);

  const quickbetClass = cx('quick-bet-notification-block', {
    'quick-bet-no-bottom-navigation': !showBottomNavigation,
  });

  return (
    <div className={quickbetClass}>
      <BetReports BetOutcomeLink={BetOutcomeLink} EventLink={EventLink} />

      <span className="label-possible-win">
        <span>{t('quick bet amount')}:</span>

        <MoneyValue currency={wallet.currency} value={amount} />
      </span>
    </div>
  );
};

export default QuickBetInfo;
